import React from 'react';
import Typography from '@mui/material/Typography';
import WrapOverText from './WrapOverText';

function ValueAssociation(props) {
  var stringValue = '';

  if (props.metadata.options === undefined) {
    stringValue = props.value;
  }
  else {
    stringValue = props.metadata.options[props.value].label;
  }

  return (
    <Typography className={props.tableCellStyle}>
      <WrapOverText wrapOver={props.wrapOver} value={stringValue} />
    </Typography>
  )
}

export default ValueAssociation;
